import React, { useState } from 'react';
import { useTimezoneSelect, allTimezones } from 'react-timezone-select';
import Input from 'src/components/Input/Input';
import { useAppDispatch, useAppSelector } from 'src/store';
import { setTimezone } from 'src/store/slices/analyticSlices';

const TimezoneSelect = () => {
  const dispatch = useAppDispatch();
  const { timezone } = useAppSelector((s) => s.analyticSlices);

  const [selectedTimezone, setSelectedTimezone] = useState(
    timezone || {
      abbrev: 'GMT',
      altName: 'British Standard Time',
      label: '(GMT+0:00) UTC',
      offset: 0,
      value: 'Etc/GMT',
    },
  );

  const { options } = useTimezoneSelect({
    labelStyle: 'original',
    timezones: allTimezones,
  });

  const handleChangeTimezone = (timezoneVal) => {
    setSelectedTimezone(timezoneVal);
    dispatch(
      setTimezone({
        timezone: timezoneVal,
      }),
    );
  };

  return (
    <div className="text-[.88rem] timezone-select">
      <Input
        inputBlockClassName="[&_.custom--dropdown-container]:max-w-[200px] [&_.custom--dropdown-container_.dropdown-selected-value]:truncate [&_.custom--dropdown-container_.dropdown-selected-value_span]:truncate"
        type={'select'}
        selectOptions={options}
        value={selectedTimezone}
        isValid={true}
        onChange={(e) => {
          handleChangeTimezone(e);
        }}
      />
    </div>
  );
};

export default TimezoneSelect;
